import { AppBar, Toolbar, Typography, useTheme, Container } from '@mui/material';
import { React, useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Homepage from './homepage';
import Blogs from './blogs';
import Projects from './projects';
import Bio from './about';
import './pages.css'


function MyNavbar() {
  const theme = useTheme();
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    function handleScroll() {
      if (window.pageYOffset > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    }

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Router>
      <AppBar position="sticky" sx={{ boxShadow: 0, px: 0 }} className={ isSticky ? 'sticky' : '' }>
        <Container sx={{ width: '100%', height: '100%' }} maxWidth="lg">
          <Toolbar disableGutters>
            <Typography variant="h6" sx={{ 
              marginRight: 'auto',
              fontSize: theme.typography.title2.fontSize, 
              fontFamily: theme.typography.title2.fontFamily, 
              letterSpacing: theme.typography.title2.letterSpacing
            }}>
              <Link to='/' className='linkStyle'>RIODPP</Link>
            </Typography>
            <Typography variant="subtitle1" sx={{ 
                fontSize: theme.typography.subtitle1.fontSize, 
                fontFamily: theme.typography.subtitle1.fontFamily, 
                letterSpacing: '2px',
                width: '100px',
                textAlign: 'center'
            }}>
              <Link to='/blog' className='linkStyle'>Blogs</Link>
            </Typography>
            <Typography variant="subtitle1" sx={{ 
              fontSize: theme.typography.subtitle1.fontSize, 
              fontFamily: theme.typography.subtitle1.fontFamily, 
              letterSpacing: '2px',
              width: '100px',
              textAlign: 'center'
             }}>
              <Link to='/project' className='linkStyle'>Projects</Link>
            </Typography>
            <Typography variant="subtitle1" sx={{ 
              fontSize: theme.typography.subtitle1.fontSize, 
              fontFamily: theme.typography.subtitle1.fontFamily, 
              letterSpacing: '2px',
              width: '100px',
              textAlign: 'center' 
             }}>
              <Link to='/about' className='linkStyle'>About</Link>
            </Typography>
          </Toolbar>
          </Container>
      </AppBar>
      <Routes>
        <Route path='/' element={<Homepage />} />
        <Route path='/blog' element={<Blogs />} />
        <Route path='/project' element={<Projects />} />
        <Route path='/about' element={<Bio />} />
        {/* <Route path='*' element={<NotFound />} /> */}
      </Routes>
    </Router>
  );
}

export default MyNavbar
